<template>
  <activity-game>
    <div class="game-fullscreen">
      <div class="game-fullscreen-actions">
        <zoom-button
          bg-color-controls="white"
          bg-color-zoom-button="purple-200"
          zoom-icon-color-active="white"
          zoom-icon-color-default="black-300"
          zoom-icon-color-hover="green-100"
          controls-icon-color-default="green-100"
          controls-icon-color-hover="green-100"
          zoom-reset-color="green-100"
          zoom-value-color="black-300"
        />
        <reset-button
          icon-color="black-300"
          icon-hover="green-100"
          @on-reset="restartGame"
        />
        <fullscreen-button
          icon-variant="#414141"
          icon-variant-hover="green-100"
        />
      </div>
      <div class="game-fullscreen-wrapper">
        <slot name="activity-fullscreen"></slot>
      </div>
    </div>
  </activity-game>
</template>

<script>
import {
  ActivityGame,
  FullscreenButton,
  ZoomButton,
  ResetButton,
} from '@discoveryeducation/components';

export default {
  name: 'GameBase',
  components: {
    ActivityGame,
    FullscreenButton,
    ResetButton,
    ZoomButton,
  },
  setup(_, { root }) {
    const restartGame = () => {
      root.onSwapComponent('IntroPage');
    };

    return {
      restartGame,
    };
  },
};
</script>

<style lang="stylus" scoped>

color-white = colors.white
color-purple-100 = colors.purple-100
color-green-100 = colors.green-100
color-green-200 = colors.green-200
color-black-500 = colors.black-500
main-bg-image = var(--main-bg-image)

.game-fullscreen
  height 100%
  overflow hidden
  position relative
  width 100%

  &-actions
    background-color color-white
    border 1px solid color-black-500
    width 100%
    height 80px
    padding 0 50px 0 60px
    display flex
    align-items center
    justify-content flex-end
    position relative
    z-index 2

  &-wrapper
    position relative
    background-repeat no-repeat
    background-position bottom
    height calc(100% - 80px)
    z-index 1

&::v-deep
  .zoom-button.zoom-main-icon
    font-size 26px !important

  .fullscreen-button
    font-size 14px
    margin-left 5px

  .zoom-controls
    border 1px solid color-purple-100

  .reset-modal
    &__title
      font-family Nunito-ExtraBold

    &-buttons
      .button
        font-family Nunito-Bold
</style>
